export const APPLICATION_STEP = 'application';
const COMPANY_REJECTED_STEP = 'company-rejected';
const DENIED_STEP = 'denied';
const PINWHEEL_ERROR_STEP = 'pinwheel-error';
const UPLOAD_DOCUMENTS_STEP = 'upload-documents';
const CLARITY_UNFREEZE_STEP = 'clarity-unfreeze';
const APPLICATION_ERROR_STEP = 'application-error';
const IN_REVIEW_STEP = 'in-review';
const MANUAL_PAYMENT_STEP = 'manual-payment';

export const dashboardButtonSteps = [
    PINWHEEL_ERROR_STEP,
    MANUAL_PAYMENT_STEP,
    DENIED_STEP,
    APPLICATION_ERROR_STEP,
    COMPANY_REJECTED_STEP,
    CLARITY_UNFREEZE_STEP,
    UPLOAD_DOCUMENTS_STEP,
    IN_REVIEW_STEP,
];
